import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { createBaneLimit, editBaneLimit, getBaneLimits,
deleteBaneReport, getActualBaneLimit } from '../../actions/reportActions'
import { Translate } from '../../../language';
import inMemoryJWT from '../../../auth/inMemoryJwt';

const ReportBaneAdmin = ({ history, createBaneLimit, editBaneLimit, getBaneLimits, getActualBaneLimit, isLoadingBaneLimits, baneLimitslist, baneActualLimit, deleteBaneReport }) => {

    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            getBaneLimits()
            getActualBaneLimit()
        })

    }, [])
    const [isEdit, setIsEdit] = useState(false)
    const [idEdit, setIdEdit] = useState('')
    const [indexEdit, setIndexEdit] = useState('')
    const [strikeQuantity, setStrikeQuantity] = useState('')
    const [banDays, setBanDays] = useState('')
    const [newBanDays, setNewBanDays] = useState('')
    const [isValidate, setValidate] = useState(false)
    const [error, setError] = useState({})
    const [isLimit, setIsLimit] = useState(false)
    const [existActualLimit, setExistActualLimit] = useState(null)


    useEffect(() => {
        setExistActualLimit(baneActualLimit)
    }, [baneActualLimit])

    console.log()
    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }
    useEffect(() => {
        if (strikeQuantity !== '' && banDays !== '' && isLimit === false) {
            setValidate(true)
            setError(prevError => ({
                ...prevError,
                ['banDays']: ''
            }));
        }
        if (strikeQuantity !== '' && isLimit === true) {
            setValidate(true)
            setError(prevError => ({
                ...prevError,
                ['banDays']: ''
            }));
        }

        if ((strikeQuantity === '' || banDays === '') && isLimit === false) {
            setValidate(false)
        }
    }, [isLimit])

    const isChecked = () => {
        console.log()
        setIsLimit(!isLimit)
        console.log()

    }

    const isEmpty = (e) => {
        if (banDays !== '' && strikeQuantity !== '') {
            setValidate(true)
        }
        console.log()
        const { name, placeholder, value } = e.target;
        if (strikeQuantity !== '' && banDays !== '' && isLimit === false) {
            setValidate(true)

        }

        if (strikeQuantity !== '' && isLimit === true) {
            setValidate(true)

        }

        if (value.length === 0) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        if (value.length !== 0) {

            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));
        }

    }


    return (
        <div className="container-mark-type-admin">
            <div className="new-edit-type-mark-container-admin">
                <div className='title-admin'>{`${isEdit ? 'Editar' : 'Nuevo'} limite baneos`}</div>
                <div className="container-inputs-new-mark">
                    <div className="text-input-admin">
                        {'Cantidad de strikes:'}
                    </div>
                    <input
                        name='strikeQuantity'
                        className='inputs-admin'
                        value={strikeQuantity}
                        onChange={(e) => {
                            setStrikeQuantity(e.target.value.trimStart())
                            if (strikeQuantity !== '' && banDays !== '' && isLimit === false) {
                                setValidate(true)
                            }

                            if (strikeQuantity !== '' && isLimit === true) {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                        type='number'
                        min='1'
                    />
                    <div className="text-error text-error-admin">{error.strikeQuantity}</div>

                    {isLimit ? <div></div> : <div className="">
                        <div className="text-input-admin">
                            {'Dias de baneo:'}
                        </div>
                        <input
                            name='banDays'
                            className='inputs-admin'
                            value={banDays}
                            onChange={(e) => {
                                setBanDays(e.target.value.trimStart())
                                if (banDays !== '' && strikeQuantity !== '') {
                                    setValidate(true)
                                }
                            }}
                            onBlur={e => isEmpty(e)}
                            onFocus={e => isFocused(e)}
                            onKeyUp={e => isEmpty(e)}
                            type='number'
                            min='1'
                        />
                    </div>}

                    {(isLimit === false && existActualLimit !== null) ? <div></div> : <div className="">
                        <div className="text-input-admin">
                            {'Dias de baneo para el limite anterior establecido:'}
                        </div>
                        <input
                            name='newBanDays'
                            className='inputs-admin'
                            value={newBanDays}
                            onChange={(e) => {
                                setNewBanDays(e.target.value.trimStart())
                            }}
                            onBlur={e => isEmpty(e)}
                            onFocus={e => isFocused(e)}
                            onKeyUp={e => isEmpty(e)}
                            type='number'
                            min='1'
                        /> </div>}
                    <div className="text-error text-error-admin">{error.banDays}</div>
                    <div className="column centerItems mt-2">
                        <input
                            name="checkIsLimit"
                            onClick={() => isChecked()}
                            onKeyUp={e => isEmpty(e)}
                            type="checkbox"
                        />
                        <div className="textBlack littleText" htmlFor="checkIsLimit">
                            Se banea al usuario con este numero de strikes
                    </div>

                    </div>
                    {isEdit ?
                        <div className="content-buttom-create-admin">
                            <button className={`btns-admin btn-create-edit btns-admin-inactive`} onClick={() => {
                                setStrikeQuantity('')
                                setBanDays('')
                                setIsLimit(false)
                                setIdEdit('')
                                setIndexEdit('')
                                setIsEdit(false)
                            }}>
                                {Translate('cancel', 'es')}
                            </button>
                            <div className="ml-1 mr-1"></div>
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => {
                                    editBaneLimit({ strikeQuantity: strikeQuantity, banDays: banDays !== '' && banDays, id: idEdit, isLimit: isLimit }, indexEdit, history)
                                    setStrikeQuantity('')
                                    setBanDays('')
                                    setIsLimit(false)
                                    setIdEdit('')
                                    setIndexEdit('')
                                    setIsEdit(false)
                                }}>
                                {Translate('edit', 'es')}
                            </button>
                        </div>

                        :
                        <div className="content-buttom-create-admin">
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => {
                                    if (isLimit === false) { createBaneLimit({ strikeQuantity: strikeQuantity.trim(), banDays: banDays.trim(), isLimit: isLimit }, history, isLimit, baneActualLimit) }
                                    if (isLimit === true && existActualLimit !== null) { createBaneLimit({ strikeQuantity: strikeQuantity.trim(), limitToClose: { id: existActualLimit._id, banDays: newBanDays } }, history, isLimit, baneActualLimit) }
                                    if (isLimit === true && existActualLimit === null) { createBaneLimit({ strikeQuantity: strikeQuantity.trim(), isLimit: isLimit }, history, isLimit, baneActualLimit) }
                                }}>
                                {Translate('create', 'es')}
                            </button>
                        </div>
                    }
                </div>
            </div>
            <div className="see-all-mark-type-admin">
                <div className='title-admin-list'>Lista de baneos existentes</div>
                <div className='wrapper-2 column-gap row-gap mt-3'>
                    {isLoadingBaneLimits ? <div>Cargando...</div> :
                        baneLimitslist.map((baneLimit, index) => (
                            <div key={baneLimit._id} className="card-admin">
                                <div className="tittle-card-admin">Cantidad de strikes: {baneLimit.strikeQuantity}</div>
                                <div className="text-content-card">Cantidad de dias de baneo: {baneLimit.banDays}</div>
                                <div className="column centerContent">
                                    <div className="btns-admin ml-1 mr-1" onClick={() => {
                                        setStrikeQuantity(baneLimit.strikeQuantity)
                                        setBanDays(baneLimit.banDays)
                                        setIdEdit(baneLimit._id)
                                        setIsLimit(baneLimit.isLimit)
                                        setIndexEdit(index)
                                        setIsEdit(true)
                                    }}>Editar</div>
                                    <div className="btns-admin btns-admin-red" onClick={() => { deleteBaneReport(baneLimit._id, index) }}>Eliminar</div>

                                </div>
                            </div>
                        ))
                    }
                </div>
                {existActualLimit === null ? <div></div> : <div>
                    <div className='title-admin-list mt-4 mb-4'> Este es el limite de strikes para banear al usuario</div>
                    <div className='wrapper-2 column-gap row-gap mt-3'>
                        <div className='card-admin'>
                            <div className="tittle-card-admin">Limite de strikes: {existActualLimit && existActualLimit.strikeQuantity}</div>
                            <div className="column centerContent">
                                <div className="btns-admin btns-admin-red mr-1" onClick={() => { editBaneLimit({ strikeQuantity: baneActualLimit.strikeQuantity, id: baneActualLimit._id, isLimit: false }, history) }}>Quitar Limite</div>
                                <div className="btns-admin btns-admin-inactive" onClick={() => { deleteBaneReport(baneActualLimit._id) }}>Eliminar</div>
                            </div>
                        </div>
                    </div>
                </div>}
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        isLoadingBaneLimits: state.postAdmin.isLoadingBaneLimits,
        baneLimitslist: state.postAdmin.baneLimitslist,
        baneActualLimit: state.postAdmin.baneActualLimit
    }
}


export default connect(mapStateToProps, { createBaneLimit, editBaneLimit, getActualBaneLimit, getBaneLimits, deleteBaneReport })(ReportBaneAdmin)